// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type FeaturedProductsState = {
    isLoading: boolean;
    error: string;
    featuredProducts: {
        [key: string]: ProductModel[];
    };
};

const initialState: FeaturedProductsState = {
    isLoading: false,
    featuredProducts: {},
    error: "",
};

const reducer = {
    "xProductList/SetFeaturedProducts": (
        draft: Draft<FeaturedProductsState>,
        action: { featuredProducts: ProductModel[]; productNumbers: string },
    ) => {
        draft.featuredProducts[action.productNumbers] = action.featuredProducts;
    },
    "xProductList/BeginLoadingFeaturedProducts": (
        draft: Draft<FeaturedProductsState>,
        action: { featuredProducts: ProductModel[]; productNumbers: string },
    ) => {
        draft.isLoading = true;
    },
    "xProductList/EndLoadingFeaturedProducts": (
        draft: Draft<FeaturedProductsState>,
        action: { featuredProducts: ProductModel[]; productNumbers: string },
    ) => {
        draft.isLoading = false;
    },
    "xProductList/FeaturedProductsError": (draft: Draft<FeaturedProductsState>, action: { error: string }) => {
        draft.error = action.error;
    },
};

const xFeaturedProducts = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xFeaturedProducts = xFeaturedProducts;

export type xFeaturedProducts = {
    xFeaturedProducts: FeaturedProductsState;
} & ApplicationState;

type FeaturedProductsReducer = {
    isLoading: typeof xFeaturedProducts;
    featuredProducts: typeof xFeaturedProducts;
    error: typeof xFeaturedProducts;
};

export type FeaturedProductsActions = Parameters<FeaturedProductsReducer[keyof FeaturedProductsReducer]>[1] | AnyAction;
